export interface ContentTagPlanGq {
  id: number;
  projectId: number;
  totalCombinationCount: number;
  processingStartTime: string;
  duplicateCheckEndTime?: string;
  mergeEndTime?: string;
}

export const ContentTagPlanGqProps = `
  id
  projectId
  totalCombinationCount
  processingStartTime
  duplicateCheckEndTime
  mergeEndTime
`;
